module.exports = __webpack_public_path__ + "d406b1f6e3901b67cc6e55a4e17d5ee2.png";